<button [routerLink]="['/gst-slab']" class="goback mb-3">
  <i class="bi bi-arrow-left"></i> GST Slab List
</button>

<div class="gstslab-form content-info">
  <div class="row mb-3">
    <div class="col-md-3 mb-3">
      <label class="form-label"
        >Display Label <span class="text-danger">*</span></label
      >
      <input
        type="text"
        class="form-control"
        placeholder="e.g. 18%"
        [(ngModel)]="gstSlab.displayLabel"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>

    <div class="col-md-3 mb-3">
      <label class="form-label"
        >Rate % <span class="text-danger">*</span></label
      >
      <input
        type="number"
        class="form-control"
        placeholder="e.g. 18"
        [(ngModel)]="gstSlab.value"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>

    <div class="col-md-3 mb-3">
      <label class="form-label"
        >Category <span class="text-danger">*</span></label
      >
      <!-- Changed select to text input -->
      <input
        type="text"
        class="form-control"
        placeholder="Enter category (e.g. STANDARD)"
        [(ngModel)]="gstSlab.category"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>

    <div class="col-md-3 mb-3">
      <label class="form-label">Sort Order</label>
      <input
        type="number"
        class="form-control"
        placeholder="e.g. 100"
        [(ngModel)]="gstSlab.sortOrder"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-12 mb-3">
      <label class="form-label">Description</label>
      <textarea
        class="form-control"
        rows="3"
        placeholder="Enter description"
        [(ngModel)]="gstSlab.description"
        [ngModelOptions]="{ standalone: true }"
      ></textarea>
    </div>
  </div>

  <div class="text-end">
    <!-- <button class="btn btn-secondary me-2" (click)="saveAsDraft()">
      <i class="bi bi-file-earmark-text"></i> Save as Draft
    </button> -->
    <button class="btn btn-success" (click)="submitGstSlab()">
      <i class="bi bi-save"></i>
      {{ gstSlab.id ? 'Update GST Slab' : 'Create GST Slab' }}
    </button>
  </div>
</div>
